import { ControlTowerClient, ControlTowerTourModel, DashboardModel, EscalatedToursModel, EscalationHistoryModel } from './../../core/services/api.service';
import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { AddEscalationHistoryAction, AddEscalationHistoryFailAction, AddEscalationHistorySuccessAction, AddNotification, ChangePriorityAction, ChangePriorityActionFailAction, ChangePriorityActionSuccessAction, EscalateTourByIdAction, EscalateTourByIdFailAction, EscalateTourByIdSuccessAction, LoadControlTowerDashboardsAction, LoadControlTowerDashboardsFailAction, LoadControlTowerDashboardsSuccessAction, LoadControlTowerToursAction, LoadControlTowerToursFailAction, LoadControlTowerToursSuccessAction, LoadEscalatedHistoryAction, LoadEscalatedHistoryFailAction, LoadEscalatedHistorySuccessAction, LoadEscalatedToursAction, LoadEscalatedToursFailAction, LoadEscalatedToursSuccessAction, MarkTourResolvedAction, MarkTourResolvedActionFailAction, MarkTourResolvedActionSuccessAction, RegisterSignalRHandlersForChatAction, RemoveNotification } from './control-tower.actions';
import { catchError, tap } from 'rxjs/operators';
import { SignalRService } from '@core/services/signalr.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { EscalationChatDialogComponent } from '@shared/components/escalation-chat-dialog/escalation-chat-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { NotificationSnackbarComponent } from '@shared/components/notification-snack-bar/notification-snack-bar.component';
import { AuthState } from '@ngxs-store/auth-store/auth.state';

export class ControlTowerStateModel {
    public showMenu: boolean;
    public isLoading: boolean;
    public isMobileMode: boolean;
    public showSpinner: boolean;
    error: any;
    public tourList: ControlTowerTourModel[];
    public escalatedTours: EscalatedToursModel[];
    public dashboards: DashboardModel[];
    public escalationHistory: EscalationHistoryModel[];
    public signalRHandlersRegistered: boolean;
    public  notifications;
}

@State<ControlTowerStateModel>({
    name: 'controlTower',
    defaults: {
        showMenu: true,
        isLoading: true,
        isMobileMode: false,
        error: null,
        showSpinner: false,
        tourList: [],
        escalatedTours: [],
        dashboards: [],
        escalationHistory: [],
        signalRHandlersRegistered: false,
        notifications: [],
    }
})
@Injectable()
export class ControlTowerState {
    constructor(private controlTowerState: ControlTowerClient,
        public signalRService: SignalRService,
        private snackBar: MatSnackBar,
        private store: Store,
        public dialog: MatDialog
    ) {}

    @Selector()
    static getIsLoading(state: ControlTowerStateModel) {
        return state.isLoading;
    }

    @Selector()
    static getControlTowerTours(state: ControlTowerStateModel) {
        return state.tourList;
    }

    @Selector()
    static getEscalatedTours(state: ControlTowerStateModel) {
        return state.escalatedTours;
    }

    @Selector()
    static getDashboards(state: ControlTowerStateModel) {
      return state.dashboards;
    }

    @Selector()
    static getEscalatedHistory(state: ControlTowerStateModel) {
        return state.escalationHistory;
    }


    @Action(LoadControlTowerToursAction)
    loadControlTowerToursAction({ dispatch, patchState }: StateContext<ControlTowerStateModel>, action: LoadControlTowerToursAction) {
        patchState({ isLoading: true });

        return this.controlTowerState.getControlTowerTours().pipe(
            tap((tours) => dispatch(new LoadControlTowerToursSuccessAction({ tours }))),
            catchError((err) => dispatch(new LoadControlTowerToursFailAction()))
        );
    }

    @Action(LoadControlTowerToursSuccessAction)
    loadControlTowerToursSuccessAction({ dispatch, patchState }: StateContext<ControlTowerStateModel>, action: LoadControlTowerToursSuccessAction) {
        patchState({
            isLoading: false,
            tourList: action.payload.tours
        });
    }

    @Action(LoadControlTowerToursFailAction)
    loadControlTowerToursFailAction(ctx: StateContext<ControlTowerStateModel>, action: LoadControlTowerToursFailAction) {
        ctx.patchState({
            isLoading: false,
            tourList: []
        });
    }

    //---------------------------------------------------------------------------------------------------------------------------------------------------

    @Action(LoadEscalatedToursAction)
    loadEscalatedToursAction({ dispatch, patchState }: StateContext<ControlTowerStateModel>, action: LoadEscalatedToursAction) {
        patchState({ isLoading: true });

        return this.controlTowerState.getEscalatedTours().pipe(
            tap((tours) => dispatch(new LoadEscalatedToursSuccessAction({ tours }))),
            catchError((err) => dispatch(new LoadEscalatedToursFailAction()))
        );
    }

    @Action(LoadEscalatedToursSuccessAction)
    loadEscalatedToursSuccessAction({ dispatch, patchState }: StateContext<ControlTowerStateModel>, action: LoadEscalatedToursSuccessAction) {
        patchState({
            isLoading: false,
            escalatedTours: action.payload.tours
        });
    }

    @Action(LoadEscalatedToursFailAction)
    loadEscalatedToursFailAction(ctx: StateContext<ControlTowerStateModel>, action: LoadEscalatedToursFailAction) {
        ctx.patchState({
            isLoading: false,
            escalatedTours: []
        });
    }

    //--------------------------------------------------------------------------

    @Action(LoadControlTowerDashboardsAction)
    loadControlTowerDashboardsAction({ dispatch, patchState }: StateContext<ControlTowerStateModel>, action: LoadControlTowerDashboardsAction) {
    patchState({ isLoading: true });
    return this.controlTowerState.getControlTowerDashboards().pipe(
      tap((dashboards) => dispatch(new LoadControlTowerDashboardsSuccessAction({ dashboards }))),
      catchError((err) => dispatch(new LoadControlTowerDashboardsFailAction()))
    );
  }

  @Action(LoadControlTowerDashboardsSuccessAction)
  loadControlTowerDashboardsSuccessAction(ctx: StateContext<ControlTowerStateModel>, action: LoadControlTowerDashboardsSuccessAction) {
    ctx.patchState({
      isLoading: false,
      dashboards: action.payload.dashboards
    });

  }

  @Action(LoadControlTowerDashboardsFailAction)
  loadControlTowerDashboardsFailAction(ctx: StateContext<ControlTowerStateModel>, action: LoadControlTowerDashboardsFailAction) {
    ctx.patchState({
      isLoading: false
    });
  }

  //------------------------------------------------------------------------------------------------------------------------------------------

  @Action(MarkTourResolvedAction)
    markTourResolvedAction({ dispatch, patchState }: StateContext<ControlTowerStateModel>, action: MarkTourResolvedAction) {
        patchState({ isLoading: true });

        return this.controlTowerState.markTourResolved(action.id, action.tourId).pipe(
            tap((tour) => {
                dispatch(new MarkTourResolvedActionSuccessAction({ tour }));
            }),
            catchError(error => {
                dispatch(new MarkTourResolvedActionFailAction());
                throw error;
            })
        );
    }

    @Action(MarkTourResolvedActionSuccessAction)
    markTourResolvedActionSuccessAction({ patchState, getState }: StateContext<ControlTowerStateModel>, action: MarkTourResolvedActionSuccessAction) {
        const state = getState();
    }

    //------------------------------------------------------------------------------------------------------------------------------------------

    @Action(EscalateTourByIdAction)
    escalateTourByIdAction({ dispatch, patchState }: StateContext<ControlTowerStateModel>, action: EscalateTourByIdAction) {
        patchState({ isLoading: true });

        return this.controlTowerState.escalateTourById(action.id, action.topic, action.message, action.isControlRoom, action.priority).pipe(
            tap((tour) => {
                dispatch(new EscalateTourByIdSuccessAction({ tour }));
            }),
            catchError(error => {
                dispatch(new EscalateTourByIdFailAction());
                throw error;
            })
        );
    }

    @Action(EscalateTourByIdSuccessAction)
    escalateTourByIdSuccessAction({ patchState, getState }: StateContext<ControlTowerStateModel>, action: EscalateTourByIdSuccessAction) {
        const state = getState();
    }

    //----------------------------------------------------------------------------------------------------------------------------------------------------

    @Action(LoadEscalatedHistoryAction)
    loadEscalatedHistoryAction({ dispatch, patchState }: StateContext<ControlTowerStateModel>, action: LoadEscalatedHistoryAction) {
        patchState({ isLoading: true });

        return this.controlTowerState.getEscalatedHistoryById(action.id, action.topic).pipe(
            tap((history) => dispatch(new LoadEscalatedHistorySuccessAction({ history }))),
            catchError((err) => dispatch(new LoadEscalatedHistoryFailAction()))
        );
    }

    @Action(LoadEscalatedHistorySuccessAction)
    loadEscalatedHistorySuccessAction({ dispatch, patchState }: StateContext<ControlTowerStateModel>, action: LoadEscalatedHistorySuccessAction) {
        patchState({
            isLoading: false,
            escalationHistory: action.payload.history
        });
    }

    @Action(LoadEscalatedHistoryFailAction)
    loadEscalatedHistoryFailAction(ctx: StateContext<ControlTowerStateModel>, action: LoadEscalatedHistoryFailAction) {
        ctx.patchState({
            isLoading: false,
            escalationHistory: []
        });
    }

    //------------------------------------------------------------------------------------------------------------------------------------------

  @Action(AddEscalationHistoryAction)
  addEscalationHistoryAction({ dispatch, patchState }: StateContext<ControlTowerStateModel>, action: AddEscalationHistoryAction) {
      patchState({ isLoading: true });

      return this.controlTowerState.addEscalationHistoryById(action.id, action.message, action.isControlRoom, action.topic).pipe(
          tap((tour) => {
              dispatch(new AddEscalationHistorySuccessAction({ tour }));
          }),
          catchError(error => {
              dispatch(new AddEscalationHistoryFailAction());
              throw error;
          })
      );
  }

  @Action(AddEscalationHistorySuccessAction)
  addEscalationHistorySuccessAction({ patchState, getState }: StateContext<ControlTowerStateModel>, action: AddEscalationHistorySuccessAction) {
      const state = getState();
  }

  //------------------------------------------------------------------------------------------------------------------------------------------

  @Action(ChangePriorityAction)
    changePriorityAction({ dispatch, patchState }: StateContext<ControlTowerStateModel>, action: ChangePriorityAction) {
        patchState({ isLoading: true });

        return this.controlTowerState.changeEscalationPriority(action.id, action.tourId, action.priority).pipe(
            tap((tour) => {
                dispatch(new ChangePriorityActionSuccessAction({ tour }));
            }),
            catchError(error => {
                dispatch(new ChangePriorityActionFailAction());
                throw error;
            })
        );
    }

    @Action(ChangePriorityActionSuccessAction)
    changePriorityActionSuccessAction({ patchState, getState }: StateContext<ControlTowerStateModel>, action: ChangePriorityActionSuccessAction) {
        const state = getState();
    }

  //---------------------------------------------------------------------------------------------------------------------------------------------

  @Action(RegisterSignalRHandlersForChatAction)
  registerSignalRHandlersForChatAction({ getState, dispatch, patchState }: StateContext<ControlTowerStateModel>, action: RegisterSignalRHandlersForChatAction) {
    console.log('Message sent back for control tower');
    this.signalRService.getHubConnection().on('SendChatMessage', (updatedChat: EscalationHistoryModel) => {
        const tourId = updatedChat.tourId;
        const amcoId = updatedChat.amcoId;
        const sender = updatedChat.createdBy;
        const messageType = updatedChat.type;

        const token = this.store.selectSnapshot(AuthState.getDecodedToken);
        const hasControlTowerUserRole = token.roles.includes("ControlTowerUser");

        let notificationMessage = '';
        if (messageType === 'ControlTower') {
          notificationMessage = `New Message for Shipment ID ${amcoId} from Control Room`;
        } else if (messageType !== 'ControlTower') {
          notificationMessage = `New Message for Shipment ID ${amcoId} from User ${sender}`;
        }

        console.log('Has control tower user role' + hasControlTowerUserRole + 'message is from' + messageType);

        if(hasControlTowerUserRole && messageType !== 'ControlTower'){
            if (notificationMessage) {
                this.store.dispatch(new AddNotification({ message: notificationMessage, tourId }));
                this.playNotificationSound();
                this.showNotificationPopup(notificationMessage, tourId, amcoId);
            }
        }

        dispatch(new LoadControlTowerDashboardsAction());
        dispatch(new LoadEscalatedToursAction());
      });

      patchState({
        signalRHandlersRegistered: true
      });
    }


    @Action(AddNotification)
    addNotification(ctx: StateContext<ControlTowerStateModel>, action: AddNotification) {
      const state = ctx.getState();
      ctx.patchState({
        notifications: [...state.notifications, action.payload],
      });
    }

    @Action(RemoveNotification)
    removeNotification(ctx: StateContext<ControlTowerStateModel>, action: RemoveNotification) {
      const state = ctx.getState();
      ctx.patchState({
        notifications: state.notifications.filter((n) => n.tourId !== action.tourId),
      });
    }

    private showNotificationPopup(message: string, shipmentId: number, amcoId: number) {
        this.snackBar.openFromComponent(NotificationSnackbarComponent, {
          data: {
            message: message,
            onView: () => this.viewNotification(shipmentId, amcoId)
          },
          duration: 0,
          verticalPosition: 'bottom',
          horizontalPosition: 'right',
          panelClass: ['notification-popup']
        });
    }


    viewNotification(shipmentId: number, amcoId: number) {
        this.openEscalationChat(shipmentId, " ", true, amcoId, "Low")
        this.store.dispatch(new RemoveNotification(shipmentId));
    }

    openEscalationChat(tourId: number, topic: string, status: boolean, amcoId: number, priority: string){
        const dialogRef = this.dialog.open(EscalationChatDialogComponent, {
            data: {
                id: tourId,
                topic: topic,
                status: status,
                amcoId: amcoId,
                prio: priority,
                isCustomsChat: false,
                hasOpenChat: false
            }, width: '650px'
        });

        dialogRef.afterClosed().subscribe(result => {});
    }

    private playNotificationSound() {
      const audio = new Audio('/assets/sounds/mixkit-bell-notification-933.wav');
      audio.play();
    }

}
